module.exports = __webpack_public_path__ + "static/media/logoSSLSeguridad.c6505ba6.png";